module.exports = __webpack_public_path__ + "img/botterbar.d9da50e5.jpg";